export default __webpack_public_path__ + "static/media/LogoBper.9c303569.svg";